import { getters } from "@/constants/state";

export default {
  [getters.FULLSCHEDULES_GETTER]: (state) => state.fullSchedules,
  [getters.FULLSCHEDULES_EXTRA_PERSONNEL_GETTER]: (state) =>
    state.extraPersonnel,
  [getters.FULLSCHEDULES_USER_SCHEDULES_GETTER]: (state) =>
    state.userFullSchedules,
};
